import { render, staticRenderFns } from "./DeleteCustomerConfrim.vue?vue&type=template&id=00e0a665&"
import script from "./DeleteCustomerConfrim.vue?vue&type=script&lang=js&"
export * from "./DeleteCustomerConfrim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports